import R from "ramda";
import { http } from "./http";

export const fetchEnvelopes = (accountId) => (
  http.get(`/accounts/${accountId}/envelopes`)
    .then(response => {
      const envelopes = R.pathOr([], ["data", "envelopes"], response);
      return { envelopes, response };
    })
);

export const requestEnvelope = (accountId) => {
  const envelope = { quantity: 1 };
  return http.post(`/accounts/${accountId}/envelopes`, envelope);
};



// WEBPACK FOOTER //
// ./src/js/api/envelopes.js